import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const followUpKeys = createQueryKeyStore({
  counselingFollowUp: {
    list: (counselingIds: Array<number>) => [counselingIds],
    detail: (counselingId: number, requestToken?: string) => [counselingId, requestToken],
  },
});
